// @ts-nocheck
import React from 'react';
import Row from "./Row/Row";
require('./style.scss');

export default function Table(props) {
    return (
        <table className="vtsReleaseTable">
            <thead>
            {props.allowUpload &&
            <tr className="vtsReleaseTableActions">
                <th colSpan={4}></th>
                <th className="text-end">
                    <a
                        className="btn btn-sm btn-secondary"
                        href="/api/onlineshop/remaining_basket/download-remaining-quantities"
                    >
                        Download
                    </a>
                </th>
                <th className="text-end">
                    <label className="btn btn-sm btn-secondary mb-0" style={{cursor: 'pointer'}}>
                        Upload
                        <input
                            type="file"
                            accept=".xlsx"
                            style={{display: 'none'}}
                            onChange={(event) => {
                                if (event.currentTarget.files && event.currentTarget.files[0]) {
                                    props.handleFileUpload(event.currentTarget.files[0]);
                                    event.currentTarget.value = '';
                                }
                            }}
                        />
                    </label>
                </th>
            </tr>
            }
            <tr>
                <th>Brand</th>
                <th>Product</th>
                <th>Flavour</th>
                <th className="text-end">Promotion price</th>
                <th className="text-end">Remaining qty</th>
                <th className="text-end">Next order</th>
            </tr>
            </thead>
            <tbody>
            {props.basketData.positions && props.basketData.positions.length > 0 && props.basketData.positions.map(function (position) {
                return <Row
                  position={position}
                  key={position.product_attribute_id}
                  handleChange={props.handleChange}
                  errorPerFlavour={props.errorPerFlavour}
                  quantity={props.qtyPerFlavour[position.product_attribute_id] ?? 0}
                />
            })}
            </tbody>
        </table>
    )
}
